import React from 'react'

type Props = {
  loading: boolean
  column: number
}

const LoaderInTable: React.FC<Props> = ({loading, column}) => {
  if (!loading) return null

  return (
    <>
      {[1, 2, 3].map((row) => (
        <tr key={row} style={{borderBottom: '1px solid #F8FAFC'}}>
          {Array.from({length: column}).map((_, i) => (
            <td key={i} style={{padding: '12px 14px'}}>
              <div
                style={{
                  height: 14,
                  borderRadius: 6,
                  width: i === 0 ? '70%' : i % 3 === 0 ? '40%' : '55%',
                  background: 'linear-gradient(90deg,#F1F5F9 25%,#E2E8F0 50%,#F1F5F9 75%)',
                  backgroundSize: '200% 100%',
                  animation: 'qd-shimmer 1.4s infinite',
                }}
              />
            </td>
          ))}
        </tr>
      ))}

      <style>{`
        @keyframes qd-shimmer {
          0%   { background-position: 200% 0; }
          100% { background-position: -200% 0; }
        }
      `}</style>
    </>
  )
}

export default LoaderInTable
